import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from '../../environments/environment';
import { AuthService } from 'src/app/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AppInsightsService {

  private appInsights: ApplicationInsights;

  constructor(private authService: AuthService) {
    this.appInsights = new ApplicationInsights({
      config: {
        connectionString: environment.appInsights.connectionString,
        enableAutoRouteTracking: true
      }
    });

    this.appInsights.loadAppInsights();
    this.appInsights.addTelemetryInitializer((envelope) => {
      const userAuthenticatedId = this.appInsights.context.user.authenticatedId;
      if (!userAuthenticatedId) {
        return false;
      }
      return true;
    });

    this.authService.activeUser.subscribe(
      (res) => {
        const userEmail = res?.username || null;
        if (userEmail) {
          this.appInsights.setAuthenticatedUserContext(userEmail);
        }
      },
      (error) => {
        console.error("Error retrieving user details:", error);
      }
    );
  }

  logPageView(name?: string, url?: string) {
    this.appInsights.trackPageView({
      name: name,
      uri: url
    });
  }

  logEvent(name: string, properties: any) {
    this.appInsights.trackEvent({ name: name }, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    this.appInsights.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    this.appInsights.trackTrace({ message: message }, properties);
  }
}
